// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c24ae274","453":"e632068d","455":"88a071c7","977":"30d73cc7"}[chunkId] + ".chunk.js";
};